function toggleAccordion(element) {
  var allItems = document.querySelectorAll(".accordion-content");
  var allIcons = document.querySelectorAll(".accordion-icon");
  var content = element.nextElementSibling;
  var icon = element.querySelector(".accordion-icon");

  allItems.forEach(function (item) {
    if (item !== content) {
      item.classList.remove("open");
    }
  });
  allIcons.forEach(function (svgIcon) {
    if (svgIcon !== icon) {
      svgIcon.classList.remove("rotate");
    }
  });

  content.classList.toggle("open");
  icon.classList.toggle("rotate");
}

var mySwiper = new Swiper(".jiggies-review-swiper", {
  init: false,
  loop: true,
  autoplay: true,
  speed: 900,
  slidesPerView: 5,
  spaceBetween: 20,
  centeredSlides: true,
  slidesPerGroup: 2, // Grouping fewer slides
  watchOverflow: true,
  grabCursor: true,
  loopFillGroupBlank: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: "auto",
      spaceBetween: 20,
    },
  },
});

const swiperTable = new Swiper(".swiper-table", {
  init: false,
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: ".table-dots",
    clickable: true,
  },
  navigation: {
    nextEl: ".table-next",
    prevEl: ".table-prev",
  },
});

function openModal(imageSrc) {
  const modalImage = document.getElementById("modalImage");
  modalImage.src = imageSrc;
  document.getElementById("imageModal").classList.remove("hiddenimp");
  resetZoom();
}

function closeModal() {
  document.getElementById("imageModal").classList.add("hiddenimp");
  resetZoom();
}

function toggleZoom() {
  const modalImage = document.getElementById("modalImage");
  const zoomContainer = document.getElementById("zoomContainer");
  const helperText = document.getElementById("helperText");

  if (modalImage.classList.contains("scale-150")) {
    modalImage.classList.remove("scale-150");
    modalImage.classList.add("scale-100");
    modalImage.classList.remove("cursor-zoom-out");
    modalImage.classList.add("cursor-zoom-in");
    zoomContainer.scrollLeft = 0;
    zoomContainer.scrollTop = 0;
    helperText.classList.remove("hiddenimp");
  } else {
    modalImage.classList.remove("scale-100");
    modalImage.classList.add("scale-150");
    modalImage.classList.remove("cursor-zoom-in");
    modalImage.classList.add("cursor-zoom-out");
    helperText.classList.add("hiddenimp");
  }
}

function resetZoom() {
  const modalImage = document.getElementById("modalImage");
  modalImage.classList.remove("scale-150", "scale-100", "cursor-zoom-in", "cursor-zoom-out");
  modalImage.classList.add("scale-100");
}

/*

function initCheckout() {
  let checkout = document.querySelector('.trigger-checkout');
  if(!checkout) return; 

  // document.querySelector('.klaviyo-form-XNNsUb')?.classList.add('hidden');
  document.querySelector('#CartDrawer-Form')?.classList.remove('hidden');
  
  checkout.addEventListener('click', function(){
    // let klaviyoForm = document.querySelector('.klaviyo-form-XNNsUb');
    // let cartItems = document.querySelector('#CartDrawer-Form');

    // klaviyoForm.classList.toggle('hidden'); 
    // cartItems.classList.toggle('hidden');
  });
}

document.addEventListener('cart:update', initCheckout);

document.addEventListener("DOMContentLoaded", function () {
  initCheckout();
  swiperTable.init();
  mySwiper.init();
});
*/

// checkout redirection 
function initCheckout() {
  let checkout = document.querySelector('.trigger-checkout');
  if (!checkout) return;

  // Ensure the cart drawer is visible
  document.querySelector('#CartDrawer-Form')?.classList.remove('hidden');

  checkout.addEventListener('click', function () {
    window.location.href = '/checkout'; // Redirects to Shopify checkout
  });
}

document.addEventListener('cart:update', initCheckout);

document.addEventListener("DOMContentLoaded", function () {
  initCheckout();
  swiperTable.init();
  mySwiper.init();
});


document.addEventListener('DOMContentLoaded', function () {
  const thumbsSwiper = new Swiper('#productGalleryThumbs', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    freeMode: true,
  });
 

  const mainSwiper = new Swiper('#productGalleryMain', {
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
});



